<template>
    <a-modal
      v-model="isWatch"
      :footer="null"
      title="查看"
      :maskClosable="false"
      :keyboard="false"
      :closable="iscloseBtn"
    >
      <div class="content-watch">
        <div class="content">
          <div class="name-box">客源</div>
          <div class="info-box">
            <h3>姓名：{{ watchInfo.lesseeName }}</h3>
            <h3>电话：{{ watchInfo.lesseePhone ? watchInfo.lesseePhone : '暂无电话' }}</h3>
            <h3>微信：{{ watchInfo.lesseeWechat ? watchInfo.lesseeWechat : '暂无微信' }}</h3>
            <h3>备用电话：{{ watchInfo.alternatePhone ? watchInfo.alternatePhone : '暂无备用电话' }}</h3>
            <div></div>
          </div>
        </div>
      </div>
      <div v-if="!iscloseBtn" class="look_goFollowUpBtn" @click="goFollowUpBtn">去跟进 ></div>
    </a-modal>
</template>

<script>
import { userSeeRecord } from '@/api/system/houses/house.js'

export default {
    props:{
        watchInfo:{
            type:Object,
            default:()=>({})
        },
        iscloseBtn:{
            type:Boolean,
            default:false
        }
    },
    watch:{
        watchInfo:{
            handler(){

            },
            deep:true,
            immediate:true
        }
    },
    data(){
        return {
            isWatch:false,
            // iscloseBtn: false, // 查看框的关闭按钮
        }
    },
    mounted(){
        this.goFollowUpBtn()
    },
    methods:{
        // 查看弹窗-去跟进弹窗
        goFollowUpBtn () {
            userSeeRecord().then((res) => {
                if (res.code === 200) {
                    this.close()
                    this.$store.commit('SET_IS_FOLLOWUP_OBJ', res.data)
                }
            })
        },
        open(){
            this.isWatch = true
        },
        close(){
            this.isWatch = false
        }
    }
}
</script>

<style lang="less" scoped>
//查看
.content-watch {
  // height: 300px;
  .title {
    height: 20px;
    line-height: 20px;
    color: #000;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
  }
  .content {
    display: flex;
    margin-left: 20px;
    margin-top: 30px;
    .name-box {
      width: 95px;
      height: 95px;
      border-radius: 50%;
      background-color: var(--ThemeColor);
      color: #fff;
      text-align: center;
      line-height: 95px;
      letter-spacing: 1px;
      font-size: 16px;
    }
    .info-box {
      margin-left: 30px;
      width: 50%;
      height: 200px;
      color: #000;
      font-size: 16px;
    }
  }
}
</style>